import { useDataLoader } from 'react-remote-data-hooks';
import React, { useEffect } from 'react';
import DropdownList, {
  DropdownListProps,
} from 'react-widgets/lib/DropdownList';

const RemoteDataDropDown: React.FunctionComponent<
  DropdownListProps & {
    loadData: () => Promise<any[]>;
    value?: any;
    defaultValue?: any;
    onChange?: (value: any) => void;
    valueField?: string;
    textField?: string | ((dataItem: any) => string);
    placeholder?: string;
    defaultItem?: any;
    itemComponent?: (model: any) => any;
    disabled?: boolean;
    dropUp?: boolean;
  }
> = (props) => {
  const { loadData, ...dropDownProps } = props;
  const { data, loading, loaded, reload } = useDataLoader(() => loadData());
  const options =
    data && props.defaultItem ? [...props.defaultItem, ...data] : data;

  return (
    <DropdownList
      {...dropDownProps}
      busy={!loaded || loading}
      data={options || []}
      filter={'contains'}
      itemComponent={props.itemComponent ?? undefined}
      dropUp={props?.dropUp}
    />
  );
};

export default RemoteDataDropDown;
